import { Meta } from "@/shared/components";
import { QueueJobs } from "@/admin/features/queueJobs";

/**
 * Страница задач очереди в выбранном статусе
 */
export function QueueJobsPage() {
  return (
    <>
      <Meta title="Задачи очереди" />
      <QueueJobs />
    </>
  );
}
